import { render, staticRenderFns } from "./NotificationNavbar.vue?vue&type=template&id=27092059"
import script from "./NotificationNavbar.vue?vue&type=script&lang=js"
export * from "./NotificationNavbar.vue?vue&type=script&lang=js"
import style0 from "./NotificationNavbar.vue?vue&type=style&index=0&id=27092059&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports